import React from "react";
import CustomInput from "../../../Components/Atoms/CustomInput";
import { useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import { MASTER_SETTINGS } from "../../../Constant";

const VisitorOtherInformation = ({ formik, type }) => {
  const { getMasterListResponse } = useSelector((state) => state.masterReducer);
  return (
    <>
      <div className="col-md-12 pt-0">
        <h6 className="mb-4">OTHER DETAILS</h6>
      </div>
      <>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">From</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="text"
            name="other_details.from"
            placeholder="Enter from"
            value={formik.values.other_details?.from}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.from &&
              formik.errors?.other_details?.from
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Destination</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="other_details.destination"
            placeholder="SELECT DESTINATION"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.other_details?.destination}
            formik={formik}
            data={getMasterListResponse?.data?.filter(
              (e) =>
                e.type === MASTER_SETTINGS.DESTINATION && e.status === "ACTIVE"
            )}
            setValue="_id"
            errorMsg={
              formik.touched?.other_details?.destination &&
              formik.errors?.other_details?.destination
            }
          />
        </div>
      </>
      <>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Level</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="text"
            name="other_details.level"
            placeholder="Enter level"
            value={formik.values.other_details?.level}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.level &&
              formik.errors?.other_details?.level
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Block</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="text"
            name="other_details.block"
            placeholder="Enter block"
            value={formik.values.other_details?.block}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.block &&
              formik.errors?.other_details?.block
            }
          />
        </div>
        <div className="col-md-2">
          <div className="d-flex">
            <p className="mb-1">Floor</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="text"
            name="other_details.floor"
            placeholder="Enter floor"
            value={formik.values.other_details?.floor}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.floor &&
              formik.errors?.other_details?.floor
            }
          />
        </div>
        <div className="col-md-2">
          <div className="d-flex">
            <p className="mb-1">Unit No</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="text"
            name="other_details.unit_no"
            placeholder="Enter unit number"
            value={formik.values.other_details?.unit_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.unit_no &&
              formik.errors?.other_details?.unit_no
            }
          />
        </div>
      </>
      <>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Type</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            setValue="_id"
            name="other_details.type"
            placeholder="SELECT TYPE"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.other_details?.type}
            formik={formik}
            data={getMasterListResponse?.data?.filter(
              (e) => e.type === MASTER_SETTINGS.TYPE && e.status === "ACTIVE"
            )}
            errorMsg={
              formik.touched?.other_details?.type &&
              formik.errors?.other_details?.type
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Purpose Of Visit</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="other_details.purpose_of_visit"
            placeholder="SELECT PURPOSE OF VISIT"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.other_details?.purpose_of_visit}
            formik={formik}
            data={getMasterListResponse?.data?.filter(
              (e) =>
                e.type === MASTER_SETTINGS.PURPOSE_OF_VISIT &&
                e.status === "ACTIVE"
            )}
            errorMsg={
              formik.touched?.other_details?.purpose_of_visit &&
              formik.errors?.other_details?.purpose_of_visit
            }
            setValue="_id"
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Client</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="other_details.client"
            placeholder="SELECT CLIENT"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.other_details?.client}
            formik={formik}
            data={getMasterListResponse?.data?.filter(
              (e) => e.type === MASTER_SETTINGS.CLIENT && e.status === "ACTIVE"
            )}
            errorMsg={
              formik.touched?.other_details?.client &&
              formik.errors?.other_details?.client
            }
            setValue="_id"
          />
        </div>
      </>
      <>
        <div className="col-md-4">
          <CustomInput
            type="text"
            upperLabel={true}
            label="Vehicle Number"
            name="other_details.vehicle_no"
            placeholder="Enter vehicle no"
            value={formik.values.other_details?.vehicle_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.vehicle_no &&
              formik.errors?.other_details?.vehicle_no
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Pass Type</p>
            {/* <p className="erroStar">*</p> */}
          </div>
          <CustomSelect
            type="text"
            name="other_details.pass_type"
            placeholder="SELECT PASS TYPE"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.other_details?.pass_type}
            formik={formik}
            data={[
              { name: "CONTRACTOR PASS", value: "CONTRACTOR PASS" },
              { name: "VISITOR PASS", value: "VISITOR PASS" },
              { name: "ACCESS CARD", value: "ACCESS CARD" },
              { name: "KEY NUMBER", value: "KEY NUMBER" },
              { name: "OTHERS", value: "OTHERS" },
            ]}
            errorMsg={
              formik.touched?.other_details?.pass_type &&
              formik.errors?.other_details?.pass_type
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Pass No</p>
            {/* <p className="erroStar">*</p> */}
          </div>
          <CustomInput
            type="text"
            name="other_details.pass_no"
            placeholder="Enter pass number"
            value={formik.values.other_details?.pass_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.other_details?.pass_no &&
              formik.errors?.other_details?.pass_no
            }
          />
        </div>
      </>
      <div className="col-md-12">
        <CustomInput
          type="text"
          multiline={true}
          upperLabel={true}
          rows={5}
          label="Remarks"
          name="other_details.remarks"
          placeholder="Enter remarks"
          value={formik.values.other_details?.remarks}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          formik={formik}
          errorMsg={
            formik.touched?.other_details?.remarks &&
            formik.errors?.other_details?.remarks
          }
        />
      </div>
    </>
  );
};

export default VisitorOtherInformation;
